import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const LazyCreateWithRovoPage: LoadableType<{}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CreateWithRovoPage" */ '../src/CreateWithRovo/CreateWithRovoPage.tsx'
			)
		).CreateWithRovoPage,
});
